import React from "react";

import { createSvgIcon } from "@mui/material/utils";

export const RebuildIcon = createSvgIcon(
 <svg
  id="Livello_1"
  data-name="Livello 1"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 20 20"
  fill="currentColor">
  <path
   d="M9.75,1.77C11.61-.08,14.37-.48,16.6.58c.2.09.33.28.37.49.04.21-.03.43-.19.58l-3.11,3.11,1.57,1.57,3.11-3.11c.15-.15.37-.22.58-.19.21.04.4.18.49.37,1.06,2.23.66,4.99-1.2,6.84-1.58,1.58-3.81,2.1-5.81,1.58l-7.3,7.3c-1.17,1.17-3.07,1.17-4.24,0s-1.17-3.07,0-4.24l7.3-7.3c-.53-2,0-4.23,1.58-5.81ZM15.09,1.46c-1.52-.36-3.2.07-4.4,1.26-1.31,1.31-1.69,3.21-1.13,4.84.08.24.02.51-.16.69L1.82,15.83c-.65.65-.65,1.7,0,2.35.65.65,1.7.65,2.35,0l7.58-7.58c.18-.18.45-.24.69-.16,1.64.56,3.53.18,4.84-1.13,1.2-1.2,1.62-2.87,1.26-4.4l-2.83,2.83c-.26.26-.68.26-.94,0l-2.51-2.51c-.13-.13-.2-.29-.2-.47s.07-.35.2-.47l2.83-2.83Z"
   fillRule="evenodd"
  />
 </svg>,
 "Rebuild"
);
